import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { DataRequestsState } from '@/types/dataRequestsState';
import { NormalizedV2Response } from '@/types/eds/api/responses/NormalizedV2Response';

export type TransactionSliceState = {
  dataRequestsStates: {
    transactionDetails: DataRequestsState;
  };

  transactionDetails: NormalizedV2Response | null;
};

const initialState: TransactionSliceState = {
  dataRequestsStates: {
    transactionDetails: {
      isLoading: false,
      isFetching: false,
      isSuccess: false,
      isError: false,
    },
  },

  transactionDetails: null,
};

const transactionDetailsSlice = createSlice({
  name: 'transactionDetails',
  initialState,
  reducers: {
    getTransactionDetails: (
      _state,
      _action: PayloadAction<{
        transactionId: string | number;
      }>,
    ) => {},
    clearTransactionDetails(state) {
      state.transactionDetails = initialState.transactionDetails;
    },
    startLoadingTransactionDetails: (state) => {
      state.dataRequestsStates.transactionDetails = {
        isLoading: true,
        isFetching:
          !state.dataRequestsStates.transactionDetails.isError &&
          !state.dataRequestsStates.transactionDetails.isSuccess,
        isError: false,
        isSuccess: false,
      };
    },
    getTransactionDetailsSuccess: (state, action: PayloadAction<NormalizedV2Response>) => {
      state.transactionDetails = action.payload;
      state.dataRequestsStates.transactionDetails = {
        isLoading: false,
        isFetching: false,
        isError: false,
        isSuccess: true,
      };
    },
    getTransactionDetailsError: (state) => {
      state.dataRequestsStates.transactionDetails = {
        isLoading: false,
        isFetching: false,
        isError: true,
        isSuccess: false,
      };
    },
  },
});

export const {
  getTransactionDetails,
  getTransactionDetailsError,
  getTransactionDetailsSuccess,
  startLoadingTransactionDetails,
  clearTransactionDetails,
} = transactionDetailsSlice.actions;

export const transactionDetailsReducer = transactionDetailsSlice.reducer;
export const transactionDetailsReducerPath = transactionDetailsSlice.reducerPath;
